// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles-m__inner__T4Zh-","text":"styles-m__text__2oWhn","outer":"styles-m__outer__NIukM"};